import { css, createGlobalStyle } from "styled-components";

// Opt-in presentation only. Keep data, callbacks, permissions and dropdown mechanics with their owners.
export const premiumListingToolbarStyles = css`
    &&.main-window-header { background: #080909; font-family: "Roboto", sans-serif; font-size: 12px; }
    && {
    /* Individual glass surfaces retain native control geometry and semantic states. */
    .frame-313369,
    .frame-313368,
    .frame-3133682,
    .frame-29,
    .frame-29-not-hoverable,
    .frame-1000011374 .frame-48,
    .new-organize-select {
        background: linear-gradient(180deg, #202224, #141617);
        border-radius: 6px;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.035);
    }
    .firstOrganize .Frame48,
    .secondOrganize .Frame48,
    .thirdOrganize .Frame48 {
        background: linear-gradient(180deg, #202224, #141617) !important;
        /* The inset border covers every edge without the shared status strip. */
        border: 0 !important;
        border-radius: 6px;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    }
    .firstOrganize .Frame48Input,
    .secondOrganize .Frame48Input,
    .thirdOrganize .Frame48Input {
        background: transparent !important;
    }
    .firstOrganize .Frame48:not(.locked):hover,
    .secondOrganize .Frame48:not(.locked):hover,
    .thirdOrganize .Frame48:not(.locked):hover {
        box-shadow: inset 0 0 0 1px rgba(239, 191, 115, 0.55);
    }
    .firstOrganize:focus-within .Frame48:not(.locked),
    .secondOrganize:focus-within .Frame48:not(.locked),
    .thirdOrganize:focus-within .Frame48:not(.locked) {
        box-shadow: inset 0 0 0 1px #efbf73;
    }
    .frame-313369,
    .frame-313368 {
        height: 37px;
        align-items: center;
    }
    .frame-313369 .checkbox { top: 0; }
    /* Native header overlays are inline descendants; portals elsewhere are untouched. */
    .firstOrganize .dropdown-overlay {
        right: auto !important;
    }
    div:not(.button-disabled) > .frame-29:not(.active):hover,
    .new-organize-select:not(.disabled):hover {
        background: linear-gradient(180deg, #302c25, #211f1b);
        box-shadow: inset 0 0 0 1px rgba(239, 191, 115, 0.55);
    }
    .filter-btn:not(.active) {
        background: linear-gradient(180deg, #202224, #141617);
        border-color: rgba(255, 255, 255, 0.1);
    }
    /* Staging Buying Intel's active #008800, without changing the global amber accent. */
    .btn-group .filter-btn.active:not(.disabled) {
        background: var(--Buttons-Green-Active, #008800) !important;
        border-color: var(--Buttons-Green-Active, #008800) !important;
        color: #fff !important;
    }
    .btn-group .filter-btn.active:not(.disabled) svg { color: #fff !important; }
    .btn-group .filter-btn:not(.active):not(.disabled):hover {
        background: #211f1b !important;
        border-color: rgba(239, 191, 115, 0.55) !important;
    }
    .icon-search:focus-visible,
    .new-organize-select:focus-visible,
    .filter-btn:not(.disabled):focus-visible {
        outline: 2px solid #efbf73 !important;
        outline-offset: 2px;
        border-radius: 6px;
    }
    .frame-1000011374 .frame-48:focus-within {
        box-shadow: inset 0 0 0 1px #efbf73;
    }
    .organize-btn-container,
    .settings-btn-container,
    .upload-btn-container {
        background: linear-gradient(145deg, #202224, #141617 55%, #0e0f10);
        border-radius: 8px;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 12px 28px rgba(0, 0, 0, 0.3);
    }

        .property-1-default-locked { background: #080909; height: auto; min-height: 37px; flex-wrap: wrap; gap: 10px; }
        .frame-1000011372, .frame-260, .frame-1000011379, .frame-1000011377 { min-width: 0; flex-wrap: wrap; gap: 8px; }
        .frame-260 { justify-content: flex-end; flex: 1 1 auto; }
        .frame-1000011379 { max-width: 100%; }
        .frame-1000011377 { display: flex; justify-content: flex-end; flex: 1 1 auto; }
        .input-selector-inverted { min-width: 0; width: 190px; max-width: 100%; flex: 0 1 190px; }
        .input-selector-inverted .FormComponentContainer { min-width: 0; width: 100%; }
        .Frame48 { height: 37px; font-size: 12px; }
        .frame-313361 { flex-wrap: wrap; gap: 8px; min-width: 0; }
        .frame-3133712, .frame-3133713 { white-space: nowrap; }
        .organize-btn-container, .settings-btn-container, .upload-btn-container { max-width: calc(100vw - 24px); right: 0; }
    }
    @media (max-width: 760px) {
        &&.main-window-header { padding: 12px; }
        && .frame-1000011377 { width: 100%; }
        && .input-selector-inverted { flex: 1 1 160px; }
        && .frame-1000011372 { flex: 1 1 100%; }
        && .frame-260 { justify-content: space-between; }
    }
`;

// FormField forwards this explicit style marker to DropdownOverlay, including its body portal.
// No global form-engine or unmarked dropdown presentation changes.
export const PremiumListingDropdownStyles = createGlobalStyle`
    [style*="--premium-listing-overlay:"] .property-1-variant-3 {
        background: linear-gradient(145deg, #202224, #141617 55%, #0e0f10);
        border-radius: 8px;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 12px 28px rgba(0, 0, 0, 0.3);
    }
    [style*="--premium-listing-overlay:"] .frame-48-dropdown {
        background: #0e0f10 !important;
        border-color: rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        align-items: center;
    }
    [style*="--premium-listing-overlay:"] .frame-48-dropdown:focus-within {
        border-color: #efbf73;
    }
    [style*="--premium-listing-overlay:"] .search-input { min-width: 0; }
    [style*="--premium-listing-overlay:"] .frame-75 {
        align-items: center;
        background: transparent;
        border-radius: 5px;
    }
    [style*="--premium-listing-overlay:"] .frame-75:not(.locked):hover {
        background: rgba(239, 191, 115, 0.08);
    }
    [style*="--premium-listing-overlay:"] .dropdown-text,
    [style*="--premium-listing-overlay:"] .dropdown-text > .align-items-center {
        display: flex;
        align-items: center;
    }
    [style*="--premium-listing-overlay:"] .dropdown-text {
        min-width: 0;
        flex: 1 1 0 !important;
    }
    [style*="--premium-listing-overlay:"] .dropdown-text > .align-items-center {
        min-width: 0;
        width: 100%;
    }
    [style*="--premium-listing-overlay:"] .dropdown-text > .align-items-center > :first-child:not(.w-100) {
        flex-shrink: 0;
    }
    [style*="--premium-listing-overlay:"] .dropdown-text .w-100 {
        width: auto !important;
        min-width: 0;
        flex: 1 1 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    [style*="--premium-listing-overlay:"] .dropdown-description {
        min-width: 0;
        flex: 0 1 auto !important;
        max-width: 40%;
    }
    [style*="--premium-listing-overlay:"] .dropdown-description:empty { display: none; }
    [style*="--premium-listing-overlay:"] .separator {
        background: rgba(255, 255, 255, 0.1);
    }
    [style*="--premium-listing-overlay:"] .frame-container > .button {
        background: linear-gradient(180deg, #252729, #17191b);
        border-radius: 6px;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    }
    [style*="--premium-listing-overlay:"] .frame-container > .button.enabled:hover {
        background: #211f1b !important;
        box-shadow: inset 0 0 0 1px rgba(239, 191, 115, 0.55);
    }

    [style*="--premium-listing-overlay:"] { font-family: "Roboto", sans-serif; font-size: 12px; }
    [style*="--premium-listing-overlay:"] .dropdownlineitem-container { overscroll-behavior: contain; }
    [style*="--premium-listing-overlay:"] .dropdown-item:focus-within { outline: 1px solid #efbf73; outline-offset: -1px; }
`;
